import { plzListB, plzListCD } from "./plzMultipliers.js"; // Change require to import

function calculateMultiplier(plz, rentalVariant) {
  const plzNumeric = parseInt(plz, 10); // Μετατροπή του PLZ σε αριθμό
  let selectedList;

  // Επιλογή λίστας με βάση το rentalVariant
  if (rentalVariant === "B") {
    selectedList = plzListB;
  } else if (rentalVariant === "C" || rentalVariant === "D") {
    selectedList = plzListCD;
  } else {
    console.error("Invalid rental variant");
    return null;
  }

  // Άμεσο ταίριασμα (Direct Match)
  if (selectedList[plzNumeric]) {
    return selectedList[plzNumeric];
  }

  // Δυναμικός υπολογισμός (Dynamic Calculation)
  return dynamicMultiplierCalculation(plzNumeric, selectedList);
}

function dynamicMultiplierCalculation(plz, plzList) {
  const plzKeys = Object.keys(plzList)
    .map(Number)
    .sort((a, b) => a - b);

  if (plzKeys.length === 0) {
    console.error("PLZ list is empty");
    return null;
  }

  // Extrapolation: Αν το PLZ είναι εκτός των γνωστών ορίων
  if (plz < plzKeys[0]) {
    const slope =
      (plzList[plzKeys[1]] - plzList[plzKeys[0]]) / (plzKeys[1] - plzKeys[0]);
    return plzList[plzKeys[0]] + slope * (plz - plzKeys[0]);
  } else if (plz > plzKeys[plzKeys.length - 1]) {
    const lastIndex = plzKeys.length - 1;
    const slope =
      (plzList[plzKeys[lastIndex]] - plzList[plzKeys[lastIndex - 1]]) /
      (plzKeys[lastIndex] - plzKeys[lastIndex - 1]);
    return plzList[plzKeys[lastIndex]] + slope * (plz - plzKeys[lastIndex]);
  }

  // Interpolation: Αν το PLZ είναι μεταξύ δύο γνωστών τιμών
  for (let i = 0; i < plzKeys.length - 1; i++) {
    if (plz > plzKeys[i] && plz < plzKeys[i + 1]) {
      const smallerMultiplier = plzList[plzKeys[i]];
      const largerMultiplier = plzList[plzKeys[i + 1]];
      return (smallerMultiplier + largerMultiplier) / 2;
    }
  }

  // Error Handling: Αν δεν μπορεί να γίνει υπολογισμός
  console.error("Unable to calculate multiplier for PLZ:", plz);
  return null;
}

export { calculateMultiplier };
